var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-alert',{attrs:{"type":"error"}},[_vm._v("\n  "+_vm._s(_vm.elementType)),_c('i',[_vm._v(" "+_vm._s(_vm.getElementType)+" ")]),_vm._v("\n  "+_vm._s(_vm.$t('cmsElement.notImplement'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }